(function() {
  'use strict';

  /**
   * Function to find and log aria-label attributes from rating stars
   */
  function logRatingStarLabels() {
    const productReviewPanel = document.getElementById('product-review-panel');
    
    if (!productReviewPanel) {
      return;
    }

    const contentListItems = productReviewPanel.querySelectorAll('.R-ContentList__item');
    
    contentListItems.forEach(function(item, index) {
      const ratingStars = item.querySelector('.R-RatingStars__stars');
      
      if (ratingStars) {
        const ariaLabel = ratingStars.getAttribute('aria-label');
        
        if (ariaLabel) {
          const parts = ariaLabel.split(' ');
          const firstValue = parts[0];
          
          if (firstValue === '1' || firstValue === '2' || firstValue === '3') {
            item.style.display = 'none';
          }
        }
      }
    });
  }

  /**
   * Function to process reviewsio carousel widget
   */
  function processReviewsioCarousel() {
    const carouselWidget = document.getElementById('reviewsio-carousel-widget');
    
    if (!carouselWidget) {
      return;
    }

    const reviewItems = carouselWidget.querySelectorAll('.R-ReviewsList__item');
    const lowRatedItems = [];
    const highRatedItems = [];
    
    reviewItems.forEach(function(item, index) {
      const ratingStars = item.querySelector('.R-RatingStars');
      
      if (ratingStars) {
        const title = ratingStars.getAttribute('title');
        
        if (title) {
          const parts = title.split(' ');
          const firstValue = parts[0];
          
          if (firstValue === '1' || firstValue === '2' || firstValue === '3') {
            lowRatedItems.push(item);
          } else if (firstValue === '4' || firstValue === '5') {
            highRatedItems.push(item);
          }
        }
      }
    });
    
    // Replace low rated items with high rated items
    lowRatedItems.forEach(function(lowItem, index) {
      if (highRatedItems.length > 0) {
        const highItemIndex = Math.floor(Math.random() * highRatedItems.length);
        const highItem = highRatedItems[highItemIndex];
        lowItem.innerHTML = highItem.innerHTML;
      }
    });
  }

  /**
   * Watch for dynamic content changes (in case reviews load asynchronously)
   */
  function watchForDynamicContent() {
    const productReviewPanelElement = document.getElementById('product-review-panel');
    
    if (productReviewPanelElement) {
      const observer = new MutationObserver(function(mutations) {
        logRatingStarLabels();
      });

      observer.observe(productReviewPanelElement, {
        childList: true,
        subtree: true
      });
    } else {
      // Try again after a short delay if panel not found
      setTimeout(function() {
        const panel = document.getElementById('product-review-panel');
        if (panel) {
          logRatingStarLabels();
          const observer = new MutationObserver(function(mutations) {
            logRatingStarLabels();
          });
          observer.observe(panel, {
            childList: true,
            subtree: true
          });
        }
      }, 500);
    }
  }

  /**
   * Trigger upsell product submit button click after clicking .product-form__submit
   */
  function handleAddToCartClick() {
    document.addEventListener('click', function(event) {
      if (!event.target.closest('.product-form__submit')) {
        return;
      }

      const variantPicker =
        event.target.closest('form')?.querySelector('.js-product-variant-picker') ||
        document.querySelector('.js-product-variant-picker');
      const selectedSwatchEl = variantPicker?.querySelector('[data-selected-swatch-value]');
      const productSizeSelected = selectedSwatchEl ? (selectedSwatchEl.textContent || '').trim() : '';

      const upsellVariantPicker = document.querySelector('.js-upsell-variant-picker');
      const upsellRadioInputs = upsellVariantPicker
        ? Array.from(upsellVariantPicker.querySelectorAll('input[type="radio"]'))
        : [];

      // Check if productSizeSelected falls within any range and click the matching radio
      if (productSizeSelected && upsellRadioInputs.length > 0) {
        const selectedSizeNum = parseInt(productSizeSelected, 10);
        if (!isNaN(selectedSizeNum)) {
          upsellRadioInputs.forEach(function(radio) {
            const radioValue = radio.value;
            if (radioValue.includes('-')) {
              const rangeParts = radioValue.split('-');
              if (rangeParts.length === 2) {
                const min = parseInt(rangeParts[0].trim(), 10);
                const max = parseInt(rangeParts[1].trim(), 10);
                if (!isNaN(min) && !isNaN(max) && selectedSizeNum >= min && selectedSizeNum <= max) {
                  radio.click();
                }
              }
            }
          });
        }
      }

      setTimeout(function() {
        const upsellForms = document.querySelectorAll('.js-upsell-product-form');
        if (!upsellForms || upsellForms.length === 0) {
          return;
        }

        // Check if variant is already in cart
        if (!window.FoxTheme || !window.FoxTheme.routes || !window.FoxTheme.routes.cart_url) {
          return;
        }

        fetch(window.FoxTheme.routes.cart_url, {
          ...window.FoxTheme.utils.fetchConfig()
        })
          .then((response) => response.json())
          .then(function(cart) {
            const upsellFormsArray = Array.from(upsellForms);

            function processUpsellFormAtIndex(index) {
              if (index >= upsellFormsArray.length) {
                return;
              }

              const upsellForm = upsellFormsArray[index];
              const variantIdInput = upsellForm.querySelector('.product-variant-id');
              if (variantIdInput && variantIdInput.value) {
                const variantId = variantIdInput.value;

                // Check if variant is already in cart
                const isInCart = cart.items && cart.items.some(function(item) {
                  return item.variant_id.toString() === variantId.toString();
                });

                // Only click button if variant is NOT in cart
                if (!isInCart) {
                  const upsellButton = upsellForm.querySelector('.js-upsell-product__submitbtn');
                  if (upsellButton) {
                    upsellButton.click();
                  }
                }
              }

              setTimeout(function() {
                processUpsellFormAtIndex(index + 1);
              }, 1000);
            }

            processUpsellFormAtIndex(0);
          })
          .catch(function(error) {
            console.error('Error checking cart:', error);
          });
      }, 1000);
    });
  }

  /**
   * Open a Klaviyo signup form when a .js-trigger-klaviyo-signup element is clicked.
   * The Klaviyo form id can be provided via a data-klaviyo-form-id attribute on the
   * trigger element, or hardcoded below in DEFAULT_KLAVIYO_FORM_ID.
   */
  function handleKlaviyoSignupTrigger() {
    // Add your Klaviyo form id here to use as a fallback when the trigger element
    // does not have a data-klaviyo-form-id attribute.
    const DEFAULT_KLAVIYO_FORM_ID = 'XHezA6';

    document.addEventListener('click', function(event) {
      const trigger = event.target.closest('.js-trigger-klaviyo-signup');
      if (!trigger) {
        return;
      }

      event.preventDefault();

      const formId = trigger.getAttribute('data-klaviyo-form-id') || DEFAULT_KLAVIYO_FORM_ID;
      if (!formId) {
        console.warn('Klaviyo signup trigger clicked but no form id was provided.');
        return;
      }

      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    });
  }

  // Wait for window to load
  window.addEventListener('load', function() {
    logRatingStarLabels();
    processReviewsioCarousel();
    watchForDynamicContent();
    handleAddToCartClick();
    handleKlaviyoSignupTrigger();
  });
})();
